import { SectionTypeValues } from '@tunasong/models'
import type { BlockRef } from '@tunasong/schemas'
import type { BlockAffordance } from './types.js'

/**
 * Fail-open section-type gate. An affordance without `sectionTypes` always
 * matches. A block whose `sectionType` is missing or not a recognized
 * SectionType also always matches — hiding an affordance the user expects is
 * worse than showing one that is slightly off-idiom.
 *
 * Spec: docs/superpowers/specs/2026-06-05-suggest-rail-consolidation-design.md §4.3
 */
export const sectionTypeMatches = (affordance: BlockAffordance, block: BlockRef): boolean => {
  if (!affordance.sectionTypes) {
    return true
  }
  const raw = block.sectionType
  if (!raw || !(SectionTypeValues as readonly string[]).includes(raw)) {
    return true
  }
  return (affordance.sectionTypes as readonly string[]).includes(raw)
}
